var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.workspaceID)?_c('div',[(_vm.type === 'noray')?_c('noray-auth',{attrs:{"workspaceID":_vm.workspaceID}}):(_vm.type === 'char')?_c('char-auth'):(_vm.type === 'dfiles')?_c('dfiles-auth'):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }